var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45)",
    d: "m1.414 1.414c-0.3613-0.3615-0.8605-0.5828-1.414-0.5828-1.107 0-1.998 0.8904-1.998 1.998v12.14h-12.14c-1.108 0-1.998 0.8911-1.998 1.998s0.8904 1.998 1.998 1.998h12.14v12.14c0 1.108 0.8911 2.001 1.998 2.001s1.998-0.8932 1.998-2.001v-12.14h12.14c1.108 0 1.998-0.8911 1.998-1.998s-0.8904-1.998-1.998-1.998h-12.14v-12.14c0-0.554-0.2229-1.054-0.5842-1.416z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c3991e054326e87b37cc512eb8f5bd87.svg";
export { ForwardRef as ReactComponent };